import clsx from 'clsx';
import s from './Header.module.scss';
import sg from '../../styles/global.module.scss';
import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonHeader,
  IonIcon,
  IonTitle,
  IonToolbar,
  isPlatform,
  useIonRouter,
} from '@ionic/react';
import { addOutline, mailOutline } from 'ionicons/icons';
import ButtonMicroWrapper from '../Buttons/ButtonMicroWrapper/ButtonMicroWrapper';
import { logoWhatsapp } from 'ionicons/icons';
import { useLocation } from 'react-router';
import { PlacesAutocomplete } from '../Location/PlacesAutocomplete';
import { useState } from 'react';
import { usePointLocation } from '../../hooks/hook.location';
import { LocationUnavailableModal } from '../LocationModal/LocationModal';
import { AnalyticEventsEnum, trackEvent } from '../../Analytics';
import { useDelayUnmount } from '../../hooks/hook.mount';

export interface HeaderProps {
  title?: string;
  backButtonText?: string;
  hideBackButton?: boolean;
  showLocationPicker?: boolean;
  routerLink__message?: string;
  routerLink__add?: string;
}

const Header: React.FC<HeaderProps> = props => {
  const router = useIonRouter();
  const { pathname } = useLocation();

  const regex = /^\/catalog\/[^\/]+\/?$/;
  const _isHelpButtonVisible = useDelayUnmount(!regex.test(pathname), 300);
  const isHelpButtonVisible = !_isHelpButtonVisible;
  // const isHelpButtonVisible = pathname.startsWith('/catalog');

  const [isOpen, setIsOpen] = useState(false);

  const location = usePointLocation();

  return (
    <IonHeader>
      <IonToolbar mode="ios">
        {!props.hideBackButton && (
          <IonButtons slot="start">
            <IonBackButton
              text={props.backButtonText}
              defaultHref="/default"
              className={clsx(
                s.IonBackButton,
                sg.Hover_Animation_Transparency,
                'disableIosSafariSwipeBlocker'
              )}
            />
          </IonButtons>
        )}

        {props.showLocationPicker && (
          <div style={{ maxWidth: '220px' }}>
            <PlacesAutocomplete
              height="35px"
              mode="header"
              openLocationVoter={() => {
                setIsOpen(true);
                trackEvent(AnalyticEventsEnum.LOCATION__HEADER_CLICKED, {
                  location: location?.description,
                });
              }}
            />

            <LocationUnavailableModal
              isOpen={isOpen}
              close={() => setIsOpen(false)}
            />
          </div>
        )}

        <IonTitle>
          <h1 className={clsx(s.IonTitle__h1)}>{props.title}</h1>
        </IonTitle>

        <IonButtons slot="end">
          {props.routerLink__message && (
            <ButtonMicroWrapper routerLink={props.routerLink__message}>
              <IonIcon
                icon={mailOutline}
                className={clsx(s.IonIcon__message)}
              />
            </ButtonMicroWrapper>
          )}

          {props.routerLink__add && (
            <ButtonMicroWrapper routerLink={props.routerLink__add}>
              <IonIcon icon={addOutline} className={clsx(s.IonIcon__add)} />
            </ButtonMicroWrapper>
          )}

          {isHelpButtonVisible && (
            <IonButton
              mode="md"
              fill="solid"
              color="success"
              shape="round"
              onClick={() => {
                router.push(
                  '/assistance',
                  'forward',
                  'push',
                  undefined
                  // animationSlide
                );
              }}
              className={clsx(
                s.IonButton__help,
                isPlatform('desktop') ? s.IonButton__help__desktop : undefined,
                'disableIosSafariSwipeBlocker'
              )}
            >
              <IonIcon
                icon={logoWhatsapp}
                style={{
                  fontSize: '24px',
                  marginRight: '5px',
                }}
              />
              <p>Quick Help</p>
            </IonButton>
          )}
        </IonButtons>
      </IonToolbar>
    </IonHeader>
  );
};

export default Header;
